module.exports = __webpack_public_path__ + "img/memoji-2.4bf8e1bd.svg";